// extracted by mini-css-extract-plugin
export var button = "fjYLm";
export var full = "XlWi+";
export var narrow = "Je7ci";